export const SPA_LOADER_ID = 'spa-loader';

export const dismissHtmlAppLoader = (): void => {
  document.getElementById(SPA_LOADER_ID)?.remove();
};
